import { cloneDeep } from 'lodash'
import { useEffect } from 'react'
import logger, { LOG_NAME } from '../../utils/logger'
import NotFoundPage from '../NotFound/NotFoundPage'
import FooterPage from './components/FooterPage/FooterPage'
import Page1 from './components/Page1-intro/Page1-intro'
import Page2 from './components/Page2-experiments/Page2-experiments'
import Page3 from './components/Page3-dark-link/Page3-dark-link'
import Page4 from './components/Page4-directions/Page4-directions'
import Page5 from './components/Page5-goals/Page5-goals'
import Page6 from './components/Page6-metric-analytic/Page6-metric-analytic'
import Page7 from './components/Page7-goal-science/Page7-goal-science'
import Page8 from './components/Page8-experiments-science/Page8-experiments-science'
import Page9 from './components/Page9-metrics-pages/Page9'
import ReportLoading from './components/ReportLoading/ReportLoading'
import { useReportInputData } from './hooks/useReportInputData'
import { useSelectReportData } from './hooks/useSelectReportData'

const Report = () => {
  const { data, isLoading, error } = useReportInputData()
  useTrackReportOpen()

  if (!data?.data && !!error) {
    return <NotFoundPage />
  }
  if (isLoading) {
    return <ReportLoading />
  }

  return (
    <div className={'report-container'}>
      <Page1 />
      <Page2 />
      <Page3 />
      <Page4 />
      <Page5 />
      <Page6 />
      <Page7 />
      <Page8 />
      <Page9 />
      <FooterPage />
    </div>
  )
}

const useTrackReportOpen = () => {
  const { report, isSalesPart } = useSelectReportData()
  const userId = report?.data?.input?.userId || ''

  useEffect(() => {
    if (!userId) return
    const reportCopy = cloneDeep(report)
    if (reportCopy?.data?.events) {
      reportCopy.data.events = {}
    }
    logger.setUserId(userId)
    logger.trackEvent(LOG_NAME.open_report, reportCopy)
    logger.setSessionUserProperty([{ key: 'disable_sales', value: !isSalesPart }])
  }, [userId])
}

export default Report
